import React, { useState, useEffect, useMemo } from 'react'
import Axios from 'axios'
import { Link, Redirect, useParams } from "react-router-dom"
import Header from './Header';
import './OpenOrders.css'
import { Host } from './App';
import real_logo from "./real_logo_green.png";
import real_l from "./real_logo.png";

function OpenOrders() {
  const [postList, setPostList] = useState([]);
  const [PoNo, setPoNo] = useState({});
  const [PartNo, setPartNo] = useState({});
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const nowDate = new Date();
  const formattedDate = nowDate.toLocaleDateString();
  const formattedTime = nowDate.toLocaleTimeString();
  const [Date1, setDate1] = useState(new Date());
  const [Postartdate, setPoStartdate] = useState('2026-01-01');
  const [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  const [customer, setCustomer] = useState({});
  const [partInternalNo, setPartInternalNo] = useState({});
  const [operators, setoperators] = useState([]);
  const [Customers, setCustomers] = useState([]);
  const [partNo, setpartNo] = useState([]);
  const [part_dataset, setpart_dataset] = useState([]);
  const [Mouldings, setMoulding] = useState(false);
  const [Woodshops, setWoodshop] = useState(false);
  const [Upholsterys, setUpholstery] = useState(false);
  const [shipped, setshipped] = useState(false);
  const [Value, setValue] = useState("OPEN ORDERS");
  const [Section, setSection] = useState("All");
  var [order, setOrder] = useState("1");
  const [Area, setArea] = useState("");
  var [Type, setType] = useState(" ");
  const [rank, setrank] = useState(false);
  var Ranked = (window.localStorage.getItem("Rank"));
  const [Upholstery_, setUpholstery_] = useState(true);
  const [Cushions, setCushions] = useState(false);
  const [Buds, setBuds] = useState(false);
  const [Pleat, setPleat] = useState(false);
  const [Drape, setDrape] = useState(false);
  const [Haru, setHaru] = useState(false);
  const [Nora, setNora] = useState(false);
  const [avro, setavro] = useState(false);
  var token = (window.localStorage.getItem("acessToken"));
  var User = JSON.parse(window.localStorage.getItem("Name"));

  const [Unit_price, setUnit_price] = useState(false);

  // Sort state: key = field name being sorted, direction = 'asc' | 'desc' | null (default order)
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const handleSort = (key) => {
    setSortConfig(prev => {
      if (prev.key === key) {
        if (prev.direction === 'asc') return { key, direction: 'desc' };
        if (prev.direction === 'desc') return { key: null, direction: null }; // 3rd click -> back to default
      }
      return { key, direction: 'asc' };
    });
  };

  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) return ' \u21C5';
    if (sortConfig.direction === 'asc') return ' \u25B2';
    if (sortConfig.direction === 'desc') return ' \u25BC';
    return ' \u21C5';
  };

  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  }, []);

  // Single source of truth for fetching data
  useEffect(() => {
    const queryParams = {
      PoNo: PoNo,
      PartNo: PartNo,
      Postartdate: Postartdate,
      Poenddate: Poenddate,
      customer: customer,
      order: order,
      section: Section,
      token: token,
      Type: Type
    };

    Axios.get(`https://` + Host + `/api/openorders/search`, { params: queryParams })
      .then((data) => {
        console.log("Fetched data:", data.data);
        setPostList(data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [PoNo, PartNo, Postartdate, Poenddate, customer, order, Type, token]);

  // Frontend filtering based on active area button
  const filteredPosts = useMemo(() => {
    let filtered = postList;
    if (Mouldings) {
      filtered = filtered.filter(item => item.MOLDING === "YES");
    } else if (Woodshops) {
      filtered = filtered.filter(item => item.WOODSHOP === "YES");
    } else if (Upholsterys) {
      filtered = filtered.filter(item => item.UPHOLSTERY === "YES");
    }
    // Note: shipped is handled separately (if needed)
    return filtered;
  }, [postList, Mouldings, Woodshops, Upholsterys]);

  // Apply column sort (click header: asc -> desc -> back to default/unsorted) on top of the filtered rows
  const sortedFilteredPosts = useMemo(() => {
    if (!sortConfig.key || !sortConfig.direction) return filteredPosts;

    const getValue = (row) => {
      if (sortConfig.key === 'UNIT_PRICE_COMBINED') return row.New_Price || row.Unit_price;
      return row[sortConfig.key];
    };

    return [...filteredPosts].sort((a, b) => {
      let aVal = getValue(a);
      let bVal = getValue(b);
      if (aVal === null || aVal === undefined) aVal = '';
      if (bVal === null || bVal === undefined) bVal = '';

      const aNum = parseFloat(aVal);
      const bNum = parseFloat(bVal);
      if (aVal !== '' && bVal !== '' && !isNaN(aNum) && !isNaN(bNum)) {
        return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
      }
      return sortConfig.direction === 'asc'
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });
  }, [filteredPosts, sortConfig]);

  // Calculate total quantity shipped based on filtered rows
  const totalQtyShipped = useMemo(() => {
    return filteredPosts.reduce((acc, val) => acc + ((val.New_Price || val.Unit_price) * val.Remained_parts), 0);
  }, [filteredPosts]);

  // Calculate maximum status count across filtered rows
  const maxStatusCount = useMemo(() => {
    let max = 0;
    filteredPosts.forEach((item) => {
      if (item.combinedStatuses) {
        const statusArray = item.combinedStatuses.split(" || ").filter(s => s.trim() !== "");
        max = Math.max(max, statusArray.length);
      }
    });
    return max;
  }, [filteredPosts]);

  // Parse statuses for a specific row
  const parseStatuses = (statusString) => {
    if (!statusString) return Array(maxStatusCount).fill("");
    const statuses = statusString.split(" || ");
    const paddedStatuses = [...statuses];
    while (paddedStatuses.length < maxStatusCount) {
      paddedStatuses.push("");
    }
    return paddedStatuses;
  };

  //get rank
  useEffect(() => {
    if (Ranked === '"Admin"') {
      setrank(true);
    }
  }, [Ranked]);

  // to retreive customers
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/Customers/${token}`).then((data) => {
      setCustomers(data.data)
    });
  }, [token])

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/partNo/${token}`).then((data) => {
      setpartNo(data.data)
    });
  }, [token])

  // to retreive part dataset
  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/part_dataset/${token}`).then((data) => {
      setpart_dataset(data.data)
    });
  }, [token])

  // Area button handler - now only sets local filter flags and resets upholstery sub-type when needed
  const area = (e) => {
    const selectedArea = e.currentTarget.value;
    console.log("Area button clicked:", selectedArea);
    if (selectedArea === "MOLDING") {
      setMoulding(true);
      setWoodshop(false);
      setUpholstery(false);
      setshipped(false);
      setValue("MOULDING OPEN ORDERS");
    } else if (selectedArea === "WOODSHOP") {
      setMoulding(false);
      setWoodshop(true);
      setUpholstery(false);
      setshipped(false);
      setValue("WOODSHOP OPEN ORDERS");
    } else if (selectedArea === "UPHOLSTERY") {
      setMoulding(false);
      setWoodshop(false);
      setUpholstery(true);
      setshipped(false);
      setValue("UPHOLSTERY OPEN ORDERS");
      // Reset sub-type to default "Upholstery" (this will trigger a backend fetch via Type change)
      setArea("Upholstery");
      setType("");
      setUpholstery_(true);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(false);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "ShippedData") {
      setMoulding(false);
      setWoodshop(false);
      setUpholstery(false);
      setshipped(true);
      setValue("Shipping Data");
    }
  };

  // Section handler - updates Area and Type based on selected value
  const handleSectionChange = (e) => {
    const selectedArea = e.target.value;
    setArea(selectedArea);

    // Set Type based on selected area
    if (selectedArea === "Upholstery") {
      setType("");
      setUpholstery_(true);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(false);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Cushions") {
      setType("Cushion");
      setUpholstery_(false);
      setCushions(true);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(false);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Buds") {
      setType("Bud");
      setUpholstery_(false);
      setCushions(false);
      setBuds(true);
      setDrape(false);
      setHaru(false);
      setPleat(false);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Drape") {
      setType("Drape");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(true);
      setHaru(false);
      setPleat(false);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Haru") {
      setType("Haru");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(true);
      setPleat(false);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Pleat") {
      setType("Pleat");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Genevieve") {
      setType("Genevieve");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Leit") {
      setType("Leit");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Stratford") {
      setType("Stratford");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Melvin") {
      setType("Melvin");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(true);
      setNora(false);
      setavro(false);
    } else if (selectedArea === "Nora") {
      setType("Nora");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(false);
      setNora(true);
      setavro(false);
    } else if (selectedArea === "avro") {
      setType("avro");
      setUpholstery_(false);
      setCushions(false);
      setBuds(false);
      setDrape(false);
      setHaru(false);
      setPleat(false);
      setNora(false);
      setavro(true);
    }
  };

  const handlePrint = () => {
    const table = document.querySelector('#alldata_openorder');
    const printWindow = window.open("", "", "height=600,width=800");
    const img = document.createElement('img');
    img.src = real_logo;

    printWindow.document.write(`
      <html>
        <head>
          <title></title>
          <style>
          h1 {
            display: inline-block;
            vertical-align: middle;
            margin: 0;
            text-align: center; /* Center the heading */
            width: 100%; /* Occupy the full width */
            font-family: Arial, sans-serif; /* Set the font family */
          }
          
          img {
            display: inline-block;
            height: 50px; /* Set the height of the image as required */
            margin-right: 10px; /* Set the spacing between the image and title as required */
          }
          
          table {
            border: 1px solid black;
            border-collapse: collapse;
            width: 100%;
            font-family: Arial, sans-serif; /* Set the font family */
          }
          
          th, td {
            border: 1px solid black;
            padding: 5px;
          }
          
          tr:nth-child(even) {
            background-color: #f2f2f2; /* Apply the table-striped style */
          }
          
          .bottom-right {
            position:relative;
            bottom: 10px;
            right: 10px;
            font-family: Arial, sans-serif; /* Set the font family */
          }
          </style>
        </head>
        <body>
  
          <h1>${img.outerHTML} </h1>
          <table class="table table-striped">${(table.innerHTML)}</table>
          <p class="bottom-right">Printed By: ${User}</p>
          <p class="bottom-right">Date Created: ${formattedDate + '  ' + formattedTime}</p>
        </body>
      </html>`
    );
    printWindow.document.querySelector('title').insertAdjacentHTML('afterbegin', `  
    `);
    printWindow.document.close();
    printWindow.focus();
  };

  return (
    <div>
      <div>
        <br></br>
      </div>

      <div className="MainPage_data">
        <div class="Container" id="openorder_box">
          <h1>{Value}</h1>
          <div className="responsive-form-group">
            <div class="row" id='openorder_filter'>
              <div class="col">
                <div class="row">
                  {/* Grab the particular Operator name */}
                  <input type='text' class="form-control form-rounded" placeholder='PO NO' list="operators" onChange={(e) => {
                    setPoNo(e.target.value)
                  }} />
                </div>
                {Upholsterys ?
                  <div class="row">
                    <select
                      type="select"
                      class="form-control form-rounded"
                      id="Area"
                      placeholder="Area"
                      name="area"
                      onChange={handleSectionChange}
                      value={Area}
                    >
                      <option value="Upholstery">Upholstery</option>
                      <option value="Cushions">Cushions/Panels</option>
                      <option value="Buds">Buds</option>
                      <option value="Pleat">Pleat</option>
                      <option value="Genevieve">Genevieve</option>
                      <option value="Leit">Leit</option>
                      <option value="Stratford">Stratford</option>
                      <option value="Drape">Drape</option>
                      <option value="Haru">Haru</option>
                      <option value="Melvin">Melvin</option>
                      <option value="Nora">Nora</option>
                      <option value="avro">Avro</option>
                    </select>
                  </div>
                  : null}
              </div>
              <div class="col">
                <div class="row">
                  {/* Grab the particular Operator name */}
                  <input type='text' class="form-control form-rounded" placeholder='PART NO' list="PartNo" onChange={(e) => {
                    setPartNo(e.target.value)
                  }} />
                  <datalist id="PartNo">
                    <option></option>
                    {partNo.map(x => {
                      return <option>{x.Part_No}</option>
                    })}
                  </datalist>
                </div>
                <div class="row">
                  <Link to="/Upholstery_Schedule">
                    <button className="btn btn-primary">Upholstery Schedule</button>
                  </Link>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col" id="moldng">
                    {/* Grab the particular dates */}
                    <input type='date' class="form-control form-rounded" placeholder='PO SHIP DATE' defaultValue={Postartdate} onChange={(e) => {
                      setPoStartdate(e.target.value)
                    }} />
                    <span class="tooltiptext">Filter By PO SHIP DATE </span>
                  </div>
                  <div class="col">
                    <input type='date' class="form-control form-rounded" placeholder='Operator' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => {
                      setPoEnddate(e.target.value)
                    }} />
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  {/* Grab the particular Customer */}
                  <input type='text' class="form-control form-rounded" placeholder='Customer' list='Customers' onChange={(e) => {
                    setCustomer(e.target.value)
                  }} />
                  <datalist id="Customers">
                    <option></option>
                    {Customers.map(x => {
                      return <option>{x.Customer}</option>
                    })}
                  </datalist>
                </div>
                <div class="row">
                  <select
                    type="select"
                    class="form-control form-rounded"
                    id="order"
                    name="order"
                    onChange={(e) => {
                      setOrder(e.target.value);
                    }}
                  >
                    <option value="1">Open Orders</option>
                    <option value="0"> Open/Closed Orders</option>
                  </select>
                </div>
              </div>
              <div class="col">
                {rank ? <button className="btn btn-success" onClick={() => { setUnit_price(!Unit_price) }}>Show Unit Price</button> : null}
                <button className="btn btn-primary" onClick={handlePrint}>Print Table</button>
              </div>
            </div>
          </div>

          {/* Replace the existing Container with row and column divs */}
          <div className="area-buttons-container">
            <button
              type="button"
              className={`area-button ${Mouldings ? 'active' : ''}`}
              value="MOLDING"
              onClick={area}
            >
              <span className="area-button-icon">🛠️</span>
              <span>MOLDING</span>
            </button>

            <button
              type="button"
              className={`area-button ${Woodshops ? 'active' : ''}`}
              value="WOODSHOP"
              onClick={area}
            >
              <span className="area-button-icon">🪚</span>
              <span>WOODSHOP</span>
            </button>

            <button
              type="button"
              className={`area-button ${Upholsterys ? 'active' : ''}`}
              value="UPHOLSTERY"
              onClick={area}
            >
              <span className="area-button-icon">🛋️</span>
              <span>UPHOLSTERY</span>
            </button>
          </div>
          <br></br>

          <div class="datatable-wide" id='alldata_openorder'>
            <table class="table table-bordered table-condensed">
              <thead>
                <tr>
                  <th onClick={() => handleSort('PO_NO')} style={{ cursor: 'pointer' }}>PO NO{getSortIndicator('PO_NO')}</th>
                  <th onClick={() => handleSort('PART_NO')} style={{ cursor: 'pointer' }}>PART NO{getSortIndicator('PART_NO')}</th>
                  <th onClick={() => handleSort('PO_SHIP_DATE')} style={{ cursor: 'pointer' }}>PO SHIP DATE{getSortIndicator('PO_SHIP_DATE')}</th>
                  <th onClick={() => handleSort('PART_DESCRIPTION')} style={{ cursor: 'pointer' }}>PART DESCRIPTION{getSortIndicator('PART_DESCRIPTION')}</th>
                  <th onClick={() => handleSort('CUSTOMER')} style={{ cursor: 'pointer' }}>CUSTOMER{getSortIndicator('CUSTOMER')}</th>
                  <th onClick={() => handleSort('Remained_parts')} style={{ cursor: 'pointer' }}>REMAINED QTY{getSortIndicator('Remained_parts')}</th>

                  {Upholsterys && avro || Upholsterys && Buds || Upholsterys && Cushions || Upholsterys && Upholstery_ ? <th onClick={() => handleSort('FABRIC_STATUS')} style={{ cursor: 'pointer' }}>FABRIC STATUS{getSortIndicator('FABRIC_STATUS')}</th> : null}
                  {Upholsterys && avro || Upholsterys && Cushions || Upholsterys && Buds || Upholsterys && Haru ? <th onClick={() => handleSort('FABRIC_STYLE')} style={{ cursor: 'pointer' }}>FABRIC STYLE / FABRIC BODY{getSortIndicator('FABRIC_STYLE')}</th> : null}
                  {Upholsterys && Cushions || Upholsterys && Buds ? <th onClick={() => handleSort('FABRIC_COLOR')} style={{ cursor: 'pointer' }}>FABRIC COLOR / FABRIC TOP{getSortIndicator('FABRIC_COLOR')}</th> : null}

                  {/* Task 2: Fabric Colour column for Upholstery only */}
                  {Upholsterys && Upholstery_ ? <th onClick={() => handleSort('FABRIC_COLOR')} style={{ cursor: 'pointer' }}>FABRIC COLOUR{getSortIndicator('FABRIC_COLOR')}</th> : null}

                  {Upholsterys && Cushions ? <th onClick={() => handleSort('ORIENTATION')} style={{ cursor: 'pointer' }}>ORIENTATION{getSortIndicator('ORIENTATION')}</th> : null}
                  {Upholsterys && Pleat || Upholsterys && Drape || Upholsterys && Nora ? <th onClick={() => handleSort('BASE_COLOR')} style={{ cursor: 'pointer' }}>BASE COLOR{getSortIndicator('BASE_COLOR')}</th> : null}
                  {Upholsterys && Nora ? <th onClick={() => handleSort('Wood_Seat_And_Back_Species')} style={{ cursor: 'pointer' }}>WOOD SEAT AND BACK SPECIES{getSortIndicator('Wood_Seat_And_Back_Species')}</th> : null}
                  {Upholsterys && Nora ? <th onClick={() => handleSort('Wood_Seat_And_Back_Stain_Color')} style={{ cursor: 'pointer' }}>WOOD SEAT AND BACK STAIN COLOUR{getSortIndicator('Wood_Seat_And_Back_Stain_Color')}</th> : null}
                  {Upholsterys && Nora ? <th onClick={() => handleSort('Seat_Pad_Fabric')} style={{ cursor: 'pointer' }}>SEAT PAD FABRIC{getSortIndicator('Seat_Pad_Fabric')}</th> : null}

                  {Upholsterys && Pleat || Upholsterys && Drape ? <th onClick={() => handleSort('FABRIC_INSIDE_BACK')} style={{ cursor: 'pointer' }}>FABRIC INSIDE BACK{getSortIndicator('FABRIC_INSIDE_BACK')}</th> : null}
                  {Upholsterys && Pleat || Upholsterys && Drape ? <th onClick={() => handleSort('FABRIC_OUTSIDE_BACK')} style={{ cursor: 'pointer' }}>FABRIC OUTSIDE BACK{getSortIndicator('FABRIC_OUTSIDE_BACK')}</th> : null}
                  {Upholsterys && Pleat || Upholsterys && Drape ? <th onClick={() => handleSort('FABRIC_SEAT')} style={{ cursor: 'pointer' }}>FABRIC SEAT{getSortIndicator('FABRIC_SEAT')}</th> : null}
                  {Upholsterys && Pleat ? <th onClick={() => handleSort('PIPING')} style={{ cursor: 'pointer' }}>PIPING{getSortIndicator('PIPING')}</th> : null}
                  {Upholsterys && Drape ? <th onClick={() => handleSort('FABRIC_BACK')} style={{ cursor: 'pointer' }}>FABRIC BACK{getSortIndicator('FABRIC_BACK')}</th> : null}
                  {Upholsterys && Haru ? <th onClick={() => handleSort('WOOD_OUTSIDE_BACK')} style={{ cursor: 'pointer' }}>WOOD OUTSIDE BACK{getSortIndicator('WOOD_OUTSIDE_BACK')}</th> : null}

                  {/* Task 1: Wood Ring column for Melvin only */}
                  {Upholsterys && Type === "Melvin" ? <th onClick={() => handleSort('Wood_Ring')} style={{ cursor: 'pointer' }}>WOOD RING{getSortIndicator('Wood_Ring')}</th> : null}

                  {Upholsterys ? <th onClick={() => handleSort('SALES_ORDER_NO')} style={{ cursor: 'pointer' }}>SALES ORDER NO{getSortIndicator('SALES_ORDER_NO')}</th> : null}

                  {/* Task 3: Dynamic Status Columns (not individually sortable - combined/derived field) */}
                  {maxStatusCount > 0 && Upholsterys && (
                    Array.from({ length: maxStatusCount }).map((_, index) => (
                      <th key={`status-${index}`}>STATUS {index + 1}</th>
                    ))
                  )}

                  <th id="comment" onClick={() => handleSort('COMMENTS')} style={{ cursor: 'pointer' }}>COMMENTS{getSortIndicator('COMMENTS')}</th>
                  {rank && Unit_price ? <th id="Unit_price" onClick={() => handleSort('UNIT_PRICE_COMBINED')} style={{ cursor: 'pointer' }}>Unit Price{getSortIndicator('UNIT_PRICE_COMBINED')}</th> : null}
                  {rank && Unit_price ? <th>Total</th> : null}
                </tr>
              </thead>

              {sortedFilteredPosts.map((val, key) => {
                const statuses = parseStatuses(val.combinedStatuses);

                return (
                  <tbody key={key}>
                    <tr>
                      <td>{val.PO_NO}</td>
                      <td>{val.PART_NO}</td>
                      <td>{(val.PO_SHIP_DATE).slice(0, 10)}</td>
                      <td>{val.PART_DESCRIPTION}</td>
                      <td>{val.CUSTOMER}</td>
                      <td>{val.Remained_parts}</td>

                      {Upholsterys && avro || Upholsterys && Buds || Upholsterys && Cushions || Upholsterys && Upholstery_ ? <td> {val.FABRIC_STATUS}</td> : null}
                      {Upholsterys && avro || Upholsterys && Cushions || Upholsterys && Buds || Upholsterys && Haru ? <td>{val.FABRIC_STYLE}</td> : null}
                      {Upholsterys && Cushions || Upholsterys && Buds ? <td>{val.FABRIC_COLOR}</td> : null}

                      {/* Task 2: Fabric Colour value for Upholstery */}
                      {Upholsterys && Upholstery_ ? <td>{val.FABRIC_COLOR}</td> : null}

                      {Upholsterys && Cushions ? <td>{val.ORIENTATION}</td> : null}
                      {Upholsterys && Pleat || Upholsterys && Drape || Upholsterys && Nora ? <td>{val.BASE_COLOR}</td> : null}
                      {Upholsterys && Nora ? <td>{val.Wood_Seat_And_Back_Species}</td> : null}
                      {Upholsterys && Nora ? <td>{val.Wood_Seat_And_Back_Stain_Color}</td> : null}
                      {Upholsterys && Nora ? <td>{val.Seat_Pad_Fabric}</td> : null}

                      {Upholsterys && Pleat || Upholsterys && Drape ? <td>{val.FABRIC_INSIDE_BACK}</td> : null}
                      {Upholsterys && Pleat || Upholsterys && Drape ? <td>{val.FABRIC_OUTSIDE_BACK}</td> : null}
                      {Upholsterys && Pleat || Upholsterys && Drape ? <td>{val.FABRIC_SEAT}</td> : null}
                      {Upholsterys && Pleat ? <td>{val.PIPING}</td> : null}
                      {Upholsterys && Drape ? <td>{val.FABRIC_BACK}</td> : null}
                      {Upholsterys && Haru ? <td>{val.WOOD_OUTSIDE_BACK}</td> : null}

                      {/* Task 1: Wood Ring value for Melvin */}
                      {Upholsterys && Type === "Melvin" ? <td>{val.Wood_Ring}</td> : null}

                      {Upholsterys ? <td>{val.SALES_ORDER_NO}</td> : null}

                      {/* Task 3: Dynamic Status Values */}
                      {maxStatusCount > 0 && Upholsterys && (
                        Array.from({ length: maxStatusCount }).map((_, index) => (
                          <td key={`status-${key}-${index}`}>{statuses[index] || ""}</td>
                        ))
                      )}

                      <td id="comment">{val.COMMENTS}</td>
                      {/*UNIT_PRICE deontes the latest price*/}
                      {rank && Unit_price ? <td id="Unit_price">{val.New_Price || val.Unit_price}</td> : null}
                      {rank && Unit_price ? <td>{((val.New_Price || val.Unit_price) * val.Remained_parts).toFixed(2)}</td> : null}
                    </tr>
                  </tbody>
                )
              })}

              {rank && Unit_price && (
                <>
                  <tr>
                    <th colSpan="6" style={{ fontSize: "x-large" }}>Final Price</th>
                    <th style={{ fontSize: "x-large" }}>${totalQtyShipped.toFixed(2)}</th>
                  </tr>
                </>
              )}
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OpenOrders